// ============================================================================
// MIN COST FLOW - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'min-cost-flow',
  name: 'Min Cost Flow',
  category: 'Graphs',
  complexity: {
    time: 'O(F * E log V)',
    space: 'O(V²)'
  },
  description: 'An algorithm for finding the maximum flow with minimum cost in a network. Each edge has both a capacity and a cost per unit of flow. It repeatedly finds minimum cost augmenting paths using shortest path algorithms.'
};
